document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".about-us-faq");
  if (!sections.length) return;

  sections.forEach((sectionEl) => {
    const allItems = sectionEl.querySelectorAll(".faq-item");

    allItems.forEach((item) => {
      const answer = item.querySelector(".faq-answer");
      const question = item.querySelector(".faq-question");
      if (!answer || !question) return;

      // start closed
      answer.style.maxHeight = "0px";

      question.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        if (isActive) {
          item.classList.remove("active");
          answer.style.maxHeight = "0px";
        } else {
          item.classList.add("active");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });
});
